







































































import {Component, Prop, Vue} from 'vue-property-decorator';
import {IEmployment} from "@/dto/payroll/IEmployment";
import SelectOption from "@/components/common/SelectOption";
import PortalSelect from "@/components/common/PortalSelect.vue";
import PortalDate from "@/components/common/PortalDate.vue";
import {
	CreateInvoicePayload,
	ServiceRecordDTO,
	ServiceRecordFilter
} from "@/components/payroll/business/services/ServiceDTO";
import ServiceInvoiceOrchestrator from "@/services/ServiceInvoiceOrchestrator";
import Application from "@/state/Application";
import {processError} from "@/utils/ComponentUtils";
import ServiceLogOrchestrator from "@/services/ServiceLogOrchestrator";

@Component({
	components: {PortalDate, PortalSelect}
})
export default class CreationServiceInvoiceModal extends Vue {

	private req = new CreateInvoicePayload()
	private logs: Array<ServiceRecordDTO> = [];

	@Prop()
	private contractors!: IEmployment[]

	@Prop()
	private callBack!: () => void;

	get contractorOptions(): SelectOption[] {
		return this.contractors.map(it => SelectOption.builder().title(it.details.name).value(it.id).build());
	}

	private save() {
		Application.startLoading()
		ServiceInvoiceOrchestrator.createInvoice(this.req).then(
			() => {
				Application.stopLoading()
				this.callBack()
			},
			err => processError(err, this)
		)
	}

	private loadLogsIfPossible() {
		if (this.req.startDate && this.req.endDate) {
			Application.startLoading()
			ServiceLogOrchestrator.getAllByFilter(
				new ServiceRecordFilter(
					{
						employerId: this.$wss.getCurrent.id,
						startDate: this.req.startDate,
						endDate: this.req.endDate,
						active: true
					}
				)
			).then(
				it => {
					this.logs = it.data
					Application.stopLoading()
				},
				err => processError(err, this)
			)
		}
	}

	private subSrtIfNeed(value: string, length = 20) {
		if (value.length > length) {
			return value.substr(0, length) + '...'
		}
		return value
	}
}
